import { IncentiveOfferTimelineStep } from 'modules/incentivesMarket/types';

export const incentiveOfferTimelineKeys = {
  PUBLISHED: 'PUBLISHED',
  WAITING_ACCEPTANCE: 'WAITING_ACCEPTANCE',
  KYC_VERIFICATION: 'KYC_VERIFICATION',
  SOCIETY_VALIDATION: 'SOCIETY_VALIDATION',
  TRANSFER: 'TRANSFER',
} as const;

export const getDefaultTimelineSteps = (): IncentiveOfferTimelineStep[] => [
  {
    key: incentiveOfferTimelineKeys.PUBLISHED,
    label: 'OfferPublished',
    icon: 'ni-offer',
    isCompleted: false,
    isCurrent: false,
  },
  {
    key: incentiveOfferTimelineKeys.WAITING_ACCEPTANCE,
    label: 'WaitingAcceptance',
    icon: 'ni-users',
    isCompleted: false,
    isCurrent: false,
  },
  {
    key: incentiveOfferTimelineKeys.KYC_VERIFICATION,
    label: 'KYCVerification',
    icon: 'ni-file-check',
    isCompleted: false,
    isCurrent: false,
  },
  {
    key: incentiveOfferTimelineKeys.SOCIETY_VALIDATION,
    label: 'SocietyValidation',
    icon: 'ni-building',
    isCompleted: false,
    isCurrent: false,
  },
  {
    key: incentiveOfferTimelineKeys.TRANSFER,
    label: 'Transfer',
    icon: 'ni-swap',
    isCompleted: false,
    isCurrent: false,
  },
];
